import $ from 'jquery';
require('slick-carousel');

function FeatureSlider(sliderSectionId) {
    // Preserve reference to original self
    var self = this;

    // Uses Slick Slider
    self.container = $(sliderSectionId);
    self.slider = self.container.find('.feature-slider__slides');
    self.slides = self.container.find(".feature-slider__slide--slick");
    self.backgroundImages = self.container.find('.feature-slider__section-background');
    self.activeClass = $(self.container).data("tab-active-class");
    self.inactiveClass = $(self.container).data("tab-inactive-class");
    self.tabs =  self.container.find('.feature-slider--tab');
    self.tadLinks = self.container.find('.feature-slider--tab');

    self.slider.slick({
        arrows: false
    });

    self.tadLinks.on('click', function(e) {
        var slideNumber = e.currentTarget.getAttribute("data-slide-number");
        self.slider.slick('slickGoTo', slideNumber, false);
        return false;
    });

    self.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        self.setActiveSlide(nextSlide);
    });

    self.setActiveSlide = function(activeSlide) {
        $(self.tabs).removeClass(self.activeClass)
        $(self.tabs[activeSlide]).addClass(self.activeClass);
        self.backgroundImages.removeClass("feature-slider__section-background--visible");
        $(self.backgroundImages[activeSlide]).addClass("feature-slider__section-background--visible");
    }

    // Set first slide to active by default
    self.setActiveSlide(0);
}

$(function() {
    if ($("#feature-slider-app").length > 0) {
        const featureSliderApp = new FeatureSlider("#feature-slider-app");
    }
});